import { UserApi, UserApiResponse } from '../../../api';
import { useContainer } from '../../useContainer';

const useGetTeamsIntegrationTeams = () => {
    const userApi = useContainer(UserApi);

    const getTeams = (): Promise<UserApiResponse.TeamsIntegrationTeamDto[]> => {
        return new Promise((resolve, reject) => {
            const { exec } = userApi.getTeamsIntegrationTeams({
                onSuccess: res => {
                    const data = res.body;
                    const teams = Array.isArray(data) ? data : data.teams;
                    resolve(teams);
                },
                onError: error => reject(error),
            });

            exec();
        });
    };

    return { getTeams };
};

export default useGetTeamsIntegrationTeams;
